import Panel from "../conponents/common/Panel";
import Equipment from "../conponents/realtime/Equipment";
import InstantDetail from "../conponents/common/InstantDetail";
import { MultiChart } from "../conponents/common/SafeChart";
import { useEffect, useState } from "react";
import { selectChartDataByType } from "../store/informationSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth, addMsg, removeMsg } from "../store/authSlice";
import { fetchEquipment, fetchInfoData } from "../store/informationSlice";

function Realtime() {
  const dispatch = useDispatch();
  const chartData = useSelector(selectChartDataByType(1));
  const [currentLayer, setCurrentLayer] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const isAuth = useSelector(selectAuth);

  useEffect(() => {
    if (isAuth) {
      dispatch(fetchEquipment({ mode: 1 }));
      dispatch(fetchInfoData({ mode: 1, date: selectedTime }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTime]);

  // 圓餅圖加總
  const pieSeries = chartData?.data?.option?.series?.find(
    (seriesItem) => seriesItem?.type === "pie"
  );
  const pieTotal = pieSeries?.data?.reduce((sum, item) => {
    const value = Number(item?.value ?? 0);
    return sum + (Number.isFinite(value) ? value : 0);
  }, 0);

  const pieTitleContent =
    pieTotal != null && pieSeries?.data?.length
      ? (
          <div className="flex w-full items-center justify-between gap-4">
            <span>{chartData?.data?.option?.title}</span>
            <span className="text-base font-normal text-white/90">
              總計：{pieTotal.toFixed(2)} kW
            </span>
          </div>
        )
      : chartData?.data?.option?.title;

  // 配置圖表數據
  const charts = [
    {
      key: "second_data",
      data: chartData?.second_data,
      title: chartData?.second_data?.option?.title,
    },
    {
      key: "main_data",
      data: chartData?.data,
      title: pieTitleContent,
      titleClassName:
        pieTotal != null && pieSeries?.data?.length
          ? "flex rounded-[16px] w-full items-center justify-between gap-4 p-2 px-4 bg-[#388296] border border-[#575757] text-white font-bold text-[20px]"
          : undefined,
    },
  ];

  // 警報（只在實時模式下觸發）
  // BUG: 頁面重整後過幾秒才出現警報
  // BUG: 切換時間就會用過去的數值觸發警報
  const handleDataUpdate = ({ sourceData, isHistoryMode, mode }) => {
    dispatch(removeMsg(`overpower`));
    if (isHistoryMode || mode !== 1) return;

    if (!sourceData || !chartData || !chartData.data || !chartData.data.option) return;
    const maxPower = sourceData.find((d) => d.type_id === 'a1')?.value;
    const sumPower = chartData.data.option.series[0].data.reduce((sum, item) => sum + item.value, 0);
    
    // console.log('maxPower:', maxPower, 'sumPower:', sumPower);
    if (maxPower && sumPower && sumPower >= maxPower) {
      const msgCode = `overpower`;  

      dispatch(addMsg({
        code: msgCode,
        msg: `用電超量警示！（${sumPower.toFixed(2)}/${maxPower.toFixed(2)} kW）`,
        timestamp: new Date().toISOString(),
        level: 'warning', 
      }));
    }
  };

  return (
    <>
      <Panel>
        <InstantDetail
          currentLayer={currentLayer}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
          onDataUpdate={handleDataUpdate}
          mode={1}
        />
      </Panel>
      <Panel>
        <Equipment
          setCurrentLayer={setCurrentLayer}
          selectedTime={selectedTime}
        />
      </Panel>
      <Panel>
        <MultiChart charts={charts} layout="horizontal" />
      </Panel>
    </>
  );
}

export default Realtime;
